export enum CampaignTypeValueType {
  Percent = 1,
  Value = 2
}

(CampaignTypeValueType as any).__typeName = 'CampaignTypeValueType';
